var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPulseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M500,983c-65.217,0-128.473-12.768-188.009-37.947c-57.514-24.324-109.169-59.151-153.531-103.513 S79.272,745.523,54.947,688.009C29.767,628.472,17,565.218,17,500c0-65.217,12.767-128.472,37.947-188.008 c24.325-57.514,59.151-109.169,103.513-153.531s96.017-79.189,153.531-103.513C371.528,29.767,434.783,17,500,17 c65.217,0,128.473,12.767,188.009,37.947c57.514,24.324,109.169,59.151,153.531,103.513 c44.361,44.362,79.188,96.017,103.513,153.531C970.233,371.528,983,434.782,983,500c0,65.218-12.768,128.473-37.947,188.009 c-24.324,57.515-59.151,109.169-103.513,153.531c-44.362,44.361-96.018,79.188-153.531,103.513 C628.473,970.232,565.217,983,500,983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B515FF",
    d: "M500,34c62.93,0,123.957,12.315,181.387,36.604c55.487,23.467,105.326,57.071,148.132,99.877 c42.807,42.806,76.409,92.645,99.877,148.132C953.685,376.043,966,437.07,966,500s-12.315,123.957-36.604,181.387 c-23.468,55.487-57.07,105.326-99.877,148.133c-42.806,42.806-92.645,76.409-148.132,99.876C623.957,953.684,562.93,966,500,966 c-62.93,0-123.958-12.315-181.387-36.604c-55.488-23.467-105.327-57.07-148.132-99.876 c-42.806-42.807-76.409-92.646-99.877-148.133C46.316,623.957,34,562.929,34,500s12.315-123.957,36.604-181.387 c23.468-55.487,57.071-105.326,99.877-148.132c42.806-42.806,92.645-76.41,148.132-99.877C376.043,46.315,437.07,34,500,34 M500,0 C223.838,0,0,223.839,0,500c0,276.162,223.838,500,500,500c276.161,0,500-223.838,500-500C1000,223.839,776.161,0,500,0L500,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-133.000000, -149.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PulseChain-Logo-Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6531,
    y1: 1149.2068,
    x2: 133.7189,
    y2: 1147.6946,
    gradientTransform: "matrix(432.0988 0 0 -400.6515 -57348.7891 460777.7813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    style: {
      stopColor: "#0080FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    style: {
      stopColor: "#8000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    style: {
      stopColor: "#E619E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    style: {
      stopColor: "#FF0000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PulseChain-Logo-Shape",
    fill: "url(#PulseChain-Logo-Shape_1_)",
    d: "M1017.312,690.147c0,3.647-0.846,7.118-2.448,10.127 L850.031,985.773c-6.99,12.11-19.909,19.567-33.892,19.567H449.861c-13.982,0-26.901-7.457-33.891-19.567L251.12,700.247 c-1.596-3.005-2.43-6.455-2.43-10.1c0-11.816,9.579-21.397,21.396-21.397h180.853l45.832,77.851l0.282,0.465 c6.116,9.822,18.986,13.021,29.012,7.119l0,0l0.519-0.316c4.623-2.9,7.97-7.466,9.341-12.764l0,0l58.402-225.767l50.146,363.471 l0.076,0.508c1.852,11.434,12.508,19.354,24.044,17.764l0,0l0.524-0.078c8.352-1.363,15.137-7.534,17.265-15.758l0,0 l70.396-272.13l28.902,49.095l0.288,0.474c3.9,6.252,10.757,10.067,18.151,10.067l0,0h191.797l0,0 C1007.732,668.75,1017.312,678.331,1017.312,690.147z M816.139,292.658c13.982,0,26.901,7.459,33.892,19.567l164.844,285.514 c1.595,3.005,2.438,6.472,2.438,10.113c0,11.818-9.58,21.398-21.396,21.398H814.468L768.636,551.4l-0.314-0.52 c-2.902-4.623-7.466-7.97-12.765-9.341l0,0l-0.498-0.122c-11.279-2.637-22.659,4.204-25.576,15.478l0,0l-58.401,225.767 l-50.146-363.472l-0.079-0.524c-1.362-8.353-7.532-15.139-15.757-17.267c-11.44-2.959-23.114,3.917-26.074,15.356l0,0 l-70.395,272.128l-28.902-49.093l-0.287-0.475c-3.901-6.252-10.758-10.066-18.151-10.066l0,0H270.086l0,0 c-11.818,0-21.396-9.58-21.396-21.398c0-3.613,0.812-7.03,2.38-10.016l164.9-285.611c6.99-12.107,19.909-19.567,33.891-19.567 H816.139z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseCircle);
export default __webpack_public_path__ + "static/media/pulseCircle.8c0d19d6c414d3565a85e0dbe21c43cb.svg";
export { ForwardRef as ReactComponent };